module.exports = __webpack_public_path__ + "img/0Q3A2626_L_Foamcore.e84571ed.jpg";